/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VoidTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {VoidTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const voidTransaction = (request: VoidTransactionRequest, options?: CashRequestOptions) => post<VoidTransactionRequest, VoidTransactionResponse>("/2.0/cash/void-transaction", request, {...options, rejectOnError: true })